import { render } from "./GameStreams.vue?vue&type=template&id=87554112&scoped=true"
import script from "./GameStreams.vue?vue&type=script&lang=js"
export * from "./GameStreams.vue?vue&type=script&lang=js"

import "./GameStreams.vue?vue&type=style&index=0&id=87554112&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-87554112"]])

export default __exports__